export default "__VITE_ASSET__C45_4yns__"